import { Col, Row } from 'antd'
import * as ROUTES from 'src/constants/routes'
import { Menu } from './menu'

const MENUS = [
  {
    label: 'Privacy Policy',
    path: ROUTES.PRIVACY_POLICY,
  },
  {
    label: 'Community Guidelines',
    path: ROUTES.COMMUNITY_GUIDELINES,
  },
  {
    label: 'Contact',
    path: ROUTES.CONTACT,
  },
  {
    label: 'FAQ',
    path: ROUTES.FAQ,
  },
  {
    label: 'Join',
    path: ROUTES.JOIN,
  },
]

export const Menus = () => (
  <Row gutter={[32, 16]}>
    {MENUS.map((menu, index) => (
      <Col key={index}>
        <Menu key={index} {...menu} />
      </Col>
    ))}
  </Row>
)
